import { Injectable, Inject, Optional } from '@angular/core';
import { ServiceDefinition, IgnoreOptions } from '../service-definitions/service-definition';

/**
 * Global class that is provided in the CoreModule. This will be imported
 * in the application AppModule. This class is responsible for generating
 * the proper service route URL
 */
@Injectable()
export class ServiceRouter {
    private domainUrl: string;
    private region: string;
    private space: string;
    private routeStrategy: string;

    // @Inject to get dependency by the token name 'AppSettings'. Should be provided
    // in the AppModule. If not, then @Optional() used to guard against case where 'AppSettings'
    // is not provided
    constructor(@Optional() @Inject('AppSettings') appSettings: any) { // Might need appSettings strong typed?
        if (appSettings) {
            this.domainUrl = appSettings.domainUrl;
            this.region = appSettings.region;
            this.routeStrategy = appSettings.routeStrategy;
            if (appSettings.space === 'dev' || appSettings.space === '' || appSettings.space === null || appSettings.space === undefined) {
                this.space = '';
            } else {
                this.space = appSettings.space;
            }
        } else {
            // Set these by default
            this.domainUrl = 'https://netx360wealth.dev.bnymellon.net';
            this.region = 'dev';
        }
    }

    // Constructs the full service URL. This will be invoked in the feature modules.
    getServiceRouteURL(serviceDefinition: ServiceDefinition, options?: { ignoreOptions: IgnoreOptions }): string {
        let version = ''; // TODO: REMOVE THIS LINE WHEN VERSION AVAILABLE
        // let version = serviceDefinition.version; // TODO: UNCOMMENT THIS LINE WHEN VERSION AVAILABLE
        let uri = serviceDefinition.uri;
        let mnemonic = serviceDefinition.mnemonic;
        let context = 'gateway';
        let region = this.region;
        let space = this.space;
        let servicePath;
        let serviceUrl;
        let domain = this.domainUrl ? this.domainUrl : '';
        let ignoreOptions: IgnoreOptions = options ? options.ignoreOptions : null;

        if (ignoreOptions && ignoreOptions.constructFor
                                 && ignoreOptions.constructFor.toUpperCase() === 'NDS') {
            return this.getNdsGatewayUrl(serviceDefinition);
        }
        const isLegacySystem = (ignoreOptions && ignoreOptions.region);
        // Build Route Url based on Route Strategy
        if (this.routeStrategy && this.routeStrategy === 'service-discovery' && !isLegacySystem) {

            servicePath = [mnemonic, region, serviceDefinition.family, serviceDefinition.appName, space,
                serviceDefinition.serviceName].filter((value) => { return value; }).join('-');
            serviceUrl = [this.domainUrl, context, this.routeStrategy, servicePath, version, uri].filter((value) => { return value; }).join('/');

        } else {

            // If region is production, set the local region variable to an empty string.
            if (this.region === 'prod') {
                region = '';
            }

            // If ignoreOptions argument provided, then set ignored fields to empty string.
            if (options && options.ignoreOptions) {
                let ignore = options.ignoreOptions;
                region = ignore.region ? '' : region;
                uri = ignore.serviceUri ? '' : serviceDefinition.uri;
                // The domain should only be ignored for webworkers, this will not work for sharing use case.
                domain = ignore.domain ? '' : domain;
                // version = ignore.serviceVersion ? '' : serviceDefinition.version;  // TODO: UNCOMMENT THIS LINE WHEN VERSION AVAILABLE
            }
            // Create the service path portion of the service URL.
            if (serviceDefinition.name) {
                servicePath = [region, serviceDefinition.name].filter((value) => { return value; }).join('-');
            } else {
                servicePath = [region, serviceDefinition.family, serviceDefinition.appName, space,
                    serviceDefinition.serviceName].filter((value) => { return value; }).join('-');
            }

            serviceUrl = [servicePath, version, uri].filter((value) => { return value; }).join('/');
            // if the domain is ignored, then the url should start with / to use the relative context.
            serviceUrl = `${domain}/${serviceUrl}`;
        }

        return serviceUrl;
    }
    
    /**
     *  Constructs the NDS Gateway URL.
     *
     *  Default service url construct will be like below
     *        ndsgateway/service-discovery/<region>-<family>-<app>-<space>-<serviceName>/<uri>
     *
     */
    getNdsGatewayUrl(serviceDefinition: ServiceDefinition): string {
        let uri = serviceDefinition.uri;
        let context = 'ndsgateway';
        let routeStrategy: string = 'service-discovery';
        let region = this.region;
        let space = this.space;
        let servicePath;
        let serviceUrl;

        if ( region === 'dev') { region = 'test'; space = 'qa'; }  else if (region === 'prod') { region = ''; }

        servicePath = [region, serviceDefinition.family, serviceDefinition.appName, space,
            serviceDefinition.serviceName].filter((value) => { return value; }).join('-');
        serviceUrl = [this.domainUrl, context, routeStrategy, servicePath, uri].filter((value) => { return value; }).join('/');
        return serviceUrl;
    }

}
